import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const d=t("niger",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M24 4.5H0V20.5H24V4.5Z"
                fill="#0DB02B" />
            <path
                d="M24 4.5H0V15.1667H24V4.5Z"
                fill="white" />
            <path
                d="M24 4.5H0V9.83333H24V4.5Z"
                fill="#E05206" />
            <path
                d="M12.001 14.7667C13.2529 14.7667 14.2677 13.7519 14.2677 12.5001C14.2677 11.2482 13.2529 10.2334 12.001 10.2334C10.7492 10.2334 9.73438 11.2482 9.73438 12.5001C9.73438 13.7519 10.7492 14.7667 12.001 14.7667Z"
                fill="#E05206" />
        </svg>
    `),o=t("niger_rounded",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_96615)">
                <path
                    d="M30 0.5H-6V24.5H30V0.5Z"
                    fill="#0DB02B" />
                <path
                    d="M30 0.5H-6V16.5H30V0.5Z"
                    fill="white" />
                <path
                    d="M30 0.5H-6V8.5H30V0.5Z"
                    fill="#E05206" />
                <path
                    d="M12.0016 15.8996C13.8793 15.8996 15.4016 14.3774 15.4016 12.4996C15.4016 10.6218 13.8793 9.09961 12.0016 9.09961C10.1238 9.09961 8.60156 10.6218 8.60156 12.4996C8.60156 14.3774 10.1238 15.8996 12.0016 15.8996Z"
                    fill="#E05206" />
            </g>
            <defs>
                <clipPath id="clip0_19477_96615">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{d as Niger,o as NigerRounded};
